namespace('arctic.views.common.frontDesk');

compass.require('compass.hotel.HotelPictureSummaryTileWidget');
compass.require('compass.tiles.NoValidHousingTileWidget');

compass.require('compass.hotel.ReservationBannerWidget');
compass.require('compass.tiles.EventInfoTileWidget');
compass.require('compass.tiles.MoreRoomsTileWidget');
compass.require('compass.tiles.RegisterTileWidget');
compass.require('compass.tiles.FolioTileWidget');

compass.require('compass.hotel.EditReservationWidget');
compass.require('compass.hotel.CancelRoomWidget');
compass.require('compass.hotel.PoliciesWidget');

compass.require('compass.account.FullFolioWidget');
compass.require('compass.account.SendConfirmationWidget');


compass.require('compass.group.GDSInfoWidget');
compass.require('compass.group.EPSInfoWidget');

compass.require('compass.hotel.GroupHotelPictureSummaryTileWidget');
compass.require('compass.tiles.GroupInvitationTileWidget');
compass.require('compass.tiles.GroupContractTileWidget');

compass.require('compass.tiles.ListLoaderTileWidget');

compass.require('compass.tiles.GroupContactTileWidget');

compass.require('compass.tiles.PaymentSummaryTileWidget');

arctic.views.common.frontDesk = function(viewport,options) {

	// starts measuring the time it takes for the view to load
	compass.startLoad('frontDesk');

	/*
	 * properties.
	 */
	var _viewport = viewport;
	var _d = jQuery.dom;
	var d = _d;
	var $j = jQuery;
	var _hotelPictureSummaryTileWidget;
	var _noValidHousingTileWidget;
	var _folioTileWidget;
	var _registerTileWidget;

	var _settings = options;

	var _divs = {};
	var _pageJSON = {};
	var me = this;
	var hasGIN = false;

	var _dialogId = ''; // dialog id for any dialogs that might be spawned on the entire pages

    var _eventTypes = {
        individual : "IndividualFrontDesk",
        group : "GroupFrontDesk",
        groupMember : "RsvpFrontDesk"
    };

    var _eventType;

	var _clearEvents = function() {
		// This is a temporary fix to help with the fact that binds to the body
		// will never get destroyed via normal means, which was causing weirdness
		var events = [
			'ListLoaderSubmissionResultsWidget.ProcessListMember',
			'ListLoaderTransferWidget.UploadList',
			'ListLoaderWidget.DownloadRoster',
			'ListLoaderWidget.GA'
		];
		_.each(events, function(e) {
			jQuery('body').unbind(e);
		});
	};

	_clearEvents();

	/*
	 * self executing constructor.
	 */
	/*
	 * create the dom nodes of this view.
	 */
	var _render = function(d) {

		if(_pageJSON.pageSpecificData.paymentRequired === true) {
			if(_pageJSON.pageSpecificData.userType == 'individual') {
				viewport.trigger(CompassEvents.Navigate, 'individualPaymentRequired');
			} else if (_pageJSON.pageSpecificData.userType == 'group'){
				_viewport.trigger(CompassEvents.Navigate, 'groupPaymentRequired');
			}
		}

        // should be called recordIdMessage
		var attendanceIdMessage = {
			individual : "Your " +  _pageJSON.pageSpecificData.officeDisplayName + " ID is: " + _pageJSON.pageSpecificData.attendanceId,
			group : "Group Name: " + _pageJSON.pageSpecificData.groupName + "<abbr title='arg'> | </abbr> " +  _pageJSON.pageSpecificData.officeDisplayName +" Group ID: " + _pageJSON.pageSpecificData.groupId,
			groupMember : "Your " + _pageJSON.pageSpecificData.officeDisplayName + " ID is: " + _pageJSON.pageSpecificData.attendanceId
		};

		var cancelledAttendanceIdMessage = "Your ID is " + _pageJSON.pageSpecificData.attendanceId;

		_divs.frontDesk = d.div({className : "frontDesk"});
		_divs.hotelTileWrapper = d.div({className : "hotelTileWrapper"});
		_divs.groupContactTile = d.div();

		//if individual or group memeber and there are no reservations
		if (_pageJSON.HotelPictureSummaryTileWidget && _pageJSON.HotelPictureSummaryTileWidget.reservationsArray.length === 0) {
			_divs.attendanceIdMessage = d.h2(
				{className : "attendanceIdMessage cancelledAttendanceIdMessage", 'aria-role': '', 'role':  ''},
				cancelledAttendanceIdMessage
			);
		}
		//if group and there are no reservations
		else if (_pageJSON.GroupHotelPictureSummaryTileWidget && _pageJSON.GroupHotelPictureSummaryTileWidget.length === 0) {
			_divs.attendanceIdMessage = d.h2(
				{className : "attendanceIdMessage cancelledAttendanceIdMessage", 'aria-role': '', 'role':  ''},
				attendanceIdMessage[_pageJSON.pageSpecificData.userType]
			);
		}
		else {
			_divs.attendanceIdMessage = d.h2(
				{className : "attendanceIdMessage", 'aria-role': '', 'role':  ''},
				attendanceIdMessage[_pageJSON.pageSpecificData.userType]
			);
		}
		_divs.hotelPictureSummary = d.div({ className : "HotelPictureSummary" });

		_divs.tileWrapper = d.div({className : "mainTileWrapper"},
			_divs.hotelPictureSummary
		);

		_divs.tileWrapper.append(_divs.groupContactTile);

        // MoreRooms prepended below based on logic.
		var tiles = _pageJSON.widgets;

		
		if (!_settings.canSendConfo) tiles = _.filter(tiles, function(item){return item[0] !== 'SendConfoTileWidget';});
        
    //map widgets to divs if they shouldn't be in _divs.tileWrapper
    var widgetDivMap = {
    	HotelPictureSummaryTileWidget : _divs.hotelPictureSummary,
    	GroupHotelPictureSummaryTileWidget : _divs.hotelPictureSummary,
    	NoValidHousingTileWidget : _divs.hotelPictureSummary,
    	GroupContactTileWidget : _divs.groupContactTile
    	//ReservationBannerWidget will be integrated with HotelPictureSummaryTileWidget
    };

    var widgetRootMap = {
    	HotelPictureSummaryTileWidget : 'hotel',
    	GroupHotelPictureSummaryTileWidget : 'hotel'
    };

    var widgetSettings = {
    	EventInfoTileWidget : function(i) {
    		return {
    			WUID : 'EventInfoTileWidget',
    			meetingInfo : _settings.meetingInfo
    		};

    	},

    	HotelPictureSummaryTileWidget : function(i) {
    		return {
    			WUID : 'HotelPictureSummaryTileWidget',
    			reservations: _pageJSON.HotelPictureSummaryTileWidget ? _pageJSON.HotelPictureSummaryTileWidget : '',
					meetingInfo : _settings.meetingInfo
    		};
    	},

    	FolioTileWidget : function(i) {
    		return {WUID : 'FolioTileWidget'};
    	},

    	SendConfoTileWidget : function(i) {
    		return {WUID : 'SendConfoTileWidget'};
    	},
    	
    	
    	NoValidHousingTileWidget : function(i) {return;},

    	MoreRoomsTileWidget : function(i) {
    		return {
    			WUID : 'MoreRoomsTileWidget',
					groupMax: _settings.groupMax,
					roomsBooked: _.reduce(_pageJSON.GroupHotelPictureSummaryTileWidget ? _pageJSON.GroupHotelPictureSummaryTileWidget : '',
						function(initialSum, thisHotel){return initialSum + thisHotel.hotelInfo.numberOfRooms;}, 0),
					categoryId: _pageJSON.pageSpecificData.categoryId ? _pageJSON.pageSpecificData.categoryId : ''
    		};
    	},

    	GroupInvitationTileWidget : function(i) {
    		return {
    			WUID : 'GroupInvitationTileWidget',
					meetingInfo: _settings.meetingInfo,
					share_settings: {
						url: "/in/rsvp/" + (_pageJSON.pageSpecificData.encoded_guid ? _pageJSON.pageSpecificData.encoded_guid : '')
					},
					values: _pageJSON.rsvpWidget ? _pageJSON.rsvpWidget : '',
					groupName : _pageJSON.pageSpecificData.groupName ? _pageJSON.pageSpecificData.groupName : ''
    		};
    	},

		ListLoaderTileWidget : function(i) {
			return {
				WUID : 'ListLoaderWidget',
				groupName : _pageJSON.pageSpecificData.groupName ? _pageJSON.pageSpecificData.groupName : '',
				isCutoff : _pageJSON.listLoaderInfo.isCutoff,
				listLoaderAllowed: _pageJSON.listLoaderInfo.listLoaderAllowed,
				commentsAllowed : _pageJSON.listLoaderInfo.commentsAllowed,
				uploadHistory : _pageJSON.listLoaderInfo.uploadHistory
			};
		},

    	GroupContactTileWidget : function(i) {
    		return {
    			WUID : 'GroupContactTileWidget',
	    		groupContact : _pageJSON.GroupContactTileWidget ? _pageJSON.GroupContactTileWidget.primaryContactInfo : ''
    		};
    	},
        GroupContractTileWidget : function(i) {
            return {
                WUID : 'GroupContractTileWidget',
                contractLink : compass.rootPrefix + '/' + compass.matchDict.meetingCode + '/' + compass.PID + '/viewGroupContract'
            };
        },
			RegisterTileWidget: function (i) {
				return {
					WUID : 'RegisterTileWidget',
					asyncLoad : true
				};
			},

    	GroupHotelPictureSummaryTileWidget : function(i) {
    		return {
    			WUID : 'GroupHotelPictureSummaryTileWidget' + i,
    			reservationsArray: [_pageJSON.GroupHotelPictureSummaryTileWidget[i]],
    			currentHotel: i + 1,
    			totalHotels: _pageJSON.GroupHotelPictureSummaryTileWidget.length
    		};
    	},

    	PaymentSummaryTileWidget : function(i) {
    		return {
    			WUID : 'PaymentSummaryTileWidget'
    		};
    	}
    };

		_.each(tiles, function(tile) {
			for (var i=0; i < tile.length; i++) {
				var widgetRoot = tile[i] in widgetRootMap ? widgetRootMap[tile[i]] : 'tiles';
				var widget = new compass[widgetRoot][tile[i]]( widgetDivMap[tile[i]] ? widgetDivMap[tile[i]] : _divs.tileWrapper, widgetSettings[tile[i]](i) );
				_widgetsSetup[tile[i]](widget);
			}
		});

		_divs.frontDesk.append(_divs.attendanceIdMessage);
		if (_settings.showExtraFrontDeskVerbiage && _pageJSON.pageSpecificData.userType === 'group') {
			_divs.frontDeskExtraVerbiage = d.div({className : "frontDeskExtraVerbiage"}, "Select a hotel below to edit your reservation, or use Group Roster to upload names and payment.");
			_divs.frontDesk.append(_divs.frontDeskExtraVerbiage);
		}

		_divs.frontDesk.append(d.div({ className : 'tileContainer', 'aria-role' : 'main', 'role':'main'},
			_divs.tileWrapper//, _divs.adContainer
		));

		_viewport.append(_divs.frontDesk);
	};

	var _widgetsSetup = {
		HotelPictureSummaryTileWidget : function(widget) {
			widget.bind('HotelPictureSummaryTileWidget.viewDetails', function (event, hotelInfo) {
				compass.loading.start();
				_dialogId = hotelInfo.id; // save the dialog id that will be used when spawning the modal dialog

				compass.trackPageView('EditReservation', {
						src : 'arctic.views.common.frontDesk'
				});

				function drawDetailsHandler(data) {
					compass.loading.stop();
					_drawDetails(hotelInfo, data);
				}

				function drawGDSDetails(data) {
					compass.loading.stop();
					_drawGDSDetails(hotelInfo, data);
				}
				
				function drawEPSDetails(data) {
					compass.loading.stop();
					_drawEPSDetails(hotelInfo, data);
				}

				if (hotelInfo.GDS) {
						jQuery.ajax({
							dataType: 'json',
							url: '/epsStayInfo',
							success: drawEPSDetails
						});
				} else {
					jQuery.ajax({
						data: {
							hotel_id : hotelInfo.hotelId,
							blocked_room_id: hotelInfo.blockedRoomId,
							housing_id: hotelInfo.housingId
						},
						dataType: 'json',
						url: '/stayInfo',
						success: drawDetailsHandler
					});
				}
			});

			var banner = new compass.hotel.ReservationBannerWidget(widget.find('.tileWrapper'), {
				WUID : 'individualReservationBannerWidget',
				message : 'Your Reservation'
			});
		},


		SendConfoTileWidget : function(widget) {
			widget.bind('SendConfoTileWidget.sendConfirmation', function(event, folioInfo) {

				
				var sendConfoPopupDiv = d.div({className:'SendConfoWidgetDiv'});

				_sendConfirmationWidget = new compass.account.SendConfirmationWidget(sendConfoPopupDiv,
					{
						WUID : 'SendConfirmationWidgetFromTile',
						meetingInfo:_settings.meetingInfo,
						email:_settings.accountInfo.email
					}
				);

				
				
				_dialog = d.dialog({
					classes: "sendConfoModal",
					contents: sendConfoPopupDiv,
					idGenerator: compass.generateId, // will apply this id to the first header it finds within the dialog
					dialogId : _dialogId // the dom id of the dialog itself
				});
				_dialogId = ''; // clear the dialog id for any other dialogs that might be spawned later

				_sendConfirmationWidget.bind('SendConfirmationWidget.sendConfirmation', function(event, eventData){
					jQuery.ajax({
						data : { email : eventData.email },
						dataType:'json',
						url:'/sendConfirmation',
						success : function(data) {
							compass.loading.stop();
							_dialog.close();
						}
					});

				});

				
			});

		},
		
		FolioTileWidget : function(widget) {
			var userTypeData = _pageJSON.pageSpecificData.userType === "group" ? {group_id:_pageJSON.pageSpecificData.groupId} :
				{attendance_id: _pageJSON.pageSpecificData.attendanceId};


			widget.bind('FolioTileWidget.viewFullFolio', function(event, folioInfo) {

				_dialogId = folioInfo.id; // save the dialog id that will be used when spawning the modal dialog

				if (_pageJSON.pageSpecificData.userType === "group") {
					compass.trackPageView('GroupFolio', {
							src : 'arctic.views.group.groupFrontDesk'
					});
				}

				else {
					compass.trackPageView('Folio', {
							src : 'arctic.views.individual.individualFrontDesk'
					});
				}

				var recapArray = [];
				jQuery.ajax({
					data: userTypeData,
					dataType:'json',
					url:'/bookedReservationCost',
					success: function(resCost){
						for(var i=0; i<resCost.reservationArray.length; i++) {
							var tempStruct={'stayRecap':resCost.reservationArray[i]};
							recapArray.push(tempStruct);
						}
						var folioPopupDiv = d.div({className:'fullFolioWidgetDiv'});

						_fullFolioWidget = new compass.account.FullFolioWidget(folioPopupDiv,
							{
								WUID : 'fullFolioTile',
								recapArray : recapArray,
								meetingInfo:_settings.meetingInfo,
								canSendConfo: _settings.canSendConfo,
								hasGIN: hasGIN,
								outstandingDeposit : resCost.outstandingDeposit,
								depositWillBeChargedTodayOrEarlier : resCost.depositWillBeChargedTodayOrEarlier,
								depositWillBeChargedAt : resCost.depositWillBeChargedAt,
								chargingInfo: _settings.chargingInfo,
								paymentInfo: _settings.paymentInfo,
								merchantOfRecord: resCost.reservationArray[0].merchant_of_record,
								depositInfo: {
									depositRequired: resCost.reservationArray[0].is_deposit_required === "Y" ? true : false,
									refundable: resCost.reservationArray[0].is_refundable === "Y" ? true : false
								}
							}
						);

						_dialog = d.dialog({
							classes: "fullFolioModal",
							contents: folioPopupDiv,
							idGenerator: compass.generateId, // will apply this id to the first header it finds within the dialog
							dialogId : _dialogId // the dom id of the dialog itself
						});
						_dialogId = ''; // clear the dialog id for any other dialogs that might be spawned later

						_fullFolioWidget.bind('ShowConfirmation', function(event){
							var action = compass.rootPrefix + '/' + compass.matchDict.meetingCode + '/' + compass.PID + '/confirmation';
							var csrf_token = $('meta[name="csrf_token"]').attr('content');

							var csrfField = d.input({
								type : 'hidden',
								value : csrf_token,
								name : 'csrf_token',
								'aria-hidden': 'true'
							});

							var form = d.form({ method : 'POST', target : '_blank', action : action }, csrfField);
							_viewport.append(form);
							form.submit();
							$j('.viewConfirmationButton').empty().append('View Confirmation');
						});

						_fullFolioWidget.bind('FullFolioWidget.emailConfirmation', function(event){
							jQuery.ajax({
								data: userTypeData,
								dataType:'json',
								url:'/sendConfirmation',
								success : function(data) {

								}
							});

						});

						_fullFolioWidget.bind('StayRecapWidget.showPolicies', showPoliciesBind);

						//EPS policies link behaviour
						_fullFolioWidget.find('.EPSStayRecapWidget .policyLink').click(function(e) {
							e.preventDefault();
							showPoliciesBind(e);
						});

						_fullFolioWidget.bind('StayRecapWidget.pleaseUpdatePaymentClicked', function (event, details) {
							_navigateTo('failedCards');
						});
						
					}
				});

				var showPoliciesBind = function(e, data) {
					//Google Analytics tracking
					switch (_eventType) {
						case 'RsvpFrontDesk':
							var gaText = 'Folio - Group Member Front Desk';
							break;
						case 'GroupFrontDesk':
							var gaText = 'Folio - Group Front Desk';
							break;
						default:
							var gaText = 'Folio - Individual Front Desk';
							break;
					}
					compass.GA.trackEvent('Hotel Policies', 'View Policies', gaText);

					//Find affiliate and call appropriate hotel-specific policy functiuon
					var affiliate = "";
					if( _pageJSON.HotelPictureSummaryTileWidget && _pageJSON.HotelPictureSummaryTileWidget.reservationsArray && _pageJSON.HotelPictureSummaryTileWidget.reservationsArray.length > 0) {
							affiliate = _pageJSON.HotelPictureSummaryTileWidget.reservationsArray[0].affiliate;
					}
					if (affiliate === "EAN") {
						showPoliciesBindGDS(e, data);
					} else {
						showPoliciesBindNormal(e, data);
					}
				};

				var showPoliciesBindGDS = function(e, data) {
					//Right now you can only book individuals for GDS
					var hotelInfo = _pageJSON.HotelPictureSummaryTileWidget.reservationsArray[0];

					//Policies function for GDS hotels
					var policiesDiv = d.div({className:'policiesContainer'});
					_policiesDialog = d.dialog({
						classes: 'hotelInfo policiesDialog',
						contents: policiesDiv,
						centerOnView: true,
						showParent: true
					});
					compass.loading.start(policiesDiv);

					//Do an ajax for policy data
					jQuery.ajax({
						dataType:'json',
						traditional: true,
						url:'/epsPolicies',
						success : function(data) {
							//Create GDS policies widget & dialog
							_policiesWidget = new compass.hotel.GDSPoliciesWidget(policiesDiv, {
								WUID: 'GDS_policiesWidget_individualinfo',
								policies: {
									gdsHotelPolicies: {
										refundable: data.refundable,
										hotelName: hotelInfo.hotelName,
										roomName: data.roomName,
										depositPolicy: data.depositPolicy,
										cancelPolicy: data.cancelPolicy,
										checkinTwentyFourHour: data.checkinTwentyFourHour,
										checkinBeginTime: data.checkinBeginTime,
										checkinEndTime: data.checkinEndTime,
										checkoutTime: data.checkoutTime,
										checkinMinAge: data.checkinMinAge,
										checkinInstructions: data.checkinInstructions,
										checkinSpecialInstructions: data.checkinSpecialInstructions,
										mandatoryFees: data.mandatoryFees,
										knowBeforeYouGo: data.knowBeforeYouGo,
										petPolicies: data.petPolicies,
										generalPolicies: data.generalPolicies,
										optionalFees: data.optionalFees,
										frontDesk: true
									} 
								},
								affiliateHandledByOurAgent: _settings.meetingInfo.affiliateHandledByOurAgent,
								phone: _settings.meetingInfo.phone
							});
						},
						complete : function() {
							compass.loading.stop();
						}
					});
				};

				var showPoliciesBindNormal = function(e, data) {
					var policiesData = { blocked_room_id : [ data.blockedRoomId ] };
					var dialogId = data.dialogId || '';
					jQuery.ajax({
						data: policiesData,
						dataType:'json',
						traditional: true,
						url:'/policies',
						success : function(data) {
							var policiesDiv = d.div({className:'policiesContainer'});

							_policiesWidget = new compass.hotel.PoliciesWidget(policiesDiv, {
								WUID : 'policiesWidget_individualPersonalInfo',
								policies: data
							});

							_policiesDialog = d.dialog({
								classes: 'personalInfo policiesDialog',
								contents: policiesDiv,
								showParent: true,
								centerOnView: true,
								idGenerator: compass.generateId,
								dialogId: dialogId
							});
						}
					});

				};

			});
		},

		NoValidHousingTileWidget : function(widget) {
		},

		RegisterTileWidget: function (widget) {
			widget.bind('RegisterTileWidget.regLinkClicked', function(event) {
				compass.GA.trackEvent('Front Desk Tile', 'Click Link', 'Reg Link');
			});
			widget.bind('RegisterTileWidget.regErrorLinkClicked', function(event) {
				compass.GA.trackEvent('Front Desk Tile', 'Click Link', 'Reg Error Link');
			});
			_registerTileWidget = widget;
		},

		GroupInvitationTileWidget : function(widget) {
			widget.bind('GroupInvitationTileWidget.customizationsSaved', function (event, data) {

				$j.ajax({
					url: '/actGroupMemberOptions',
					type: 'POST',
					data: data,
					success: function () {
					}
				});
			});
		},

		ListLoaderTileWidget : function(widget) {
		},

		GroupHotelPictureSummaryTileWidget : function(widget) {
			widget.bind('GroupHotelPictureSummaryTileWidget.Modify', function (event, details) {
				_navigateTo("groupManage");
			});
		},

		MoreRoomsTileWidget : function(widget) {
			widget.bind('MoreRoomsTileWidget.findMoreRooms', function() {
				_navigateTo('hotels');
			});
		},

		EventInfoTileWidget:function(widget){
		},

		ReservationBannerWidget:function(widget){
		},

		GroupContactTileWidget:function(widget){
		},

		PaymentSummaryTileWidget:function(widget){
		},

        GroupContractTileWidget:function(widget){
        }

	};

	//used in HotelPictureSummaryTileWidget
	var _drawDetails = function (hotelInfo, info) {
		var stay = {};
		for (var i=0; i < info.stay.rooms.length; i++) {
			if (info.stay.rooms[i].housingId === hotelInfo.housingId) {
				stay = info.stay.rooms[i];
			}
		}

        var _info = info;


		var _handleUpdate = function (event, stayData) {
			var data = {
				'context': _eventType,
				'housing_id': stayData.housingId
			};

			if (stayData.frequentGuestNumber) {
				data.frequentGuestNumber = stayData.frequentGuestNumber;
			}

			var currentRoomTypeId = stayData.roomTypeId;

			if (stayData.payment) {
				data.payment_info = JSON.stringify(stayData.payment);
			}
			
			if (stayData.stay) {
				var orig = _.find(info.stay.rooms, function(room) {
					return room.housingId === stayData.housingId;
				});
				var updated = stayData.stay.stays[0];
				if (updated.arrive !== orig.arrive ||
						updated.depart !== orig.depart ||
						currentRoomTypeId != orig.blockedRoomId) {
					data.arrive = updated.arrive;
					data.depart = updated.depart;
					data.blocked_room_id = currentRoomTypeId;
				}
			}

			// There are always 2 keys
			// if less than 2 there is nothing to update, just close the dialog
			if (Object.keys(data).length <= 2) {
				compass.loading.stop();
				_dialog.close();
				window.location.reload();
				return;
			}

			function actModify() {
				return jQuery.ajax({
					url: "/actModify",
					type: 'POST',
					data: data
				});
			}
			
			function sendConfirmation() {
				return jQuery.ajax({
					url: '/sendConfirmation'
				});
			}
			
			function saveRequests() {
				return jQuery.ajax({
					data: {
						requests: JSON.stringify(stayData.roomRequests.requests),
						housing_id: stayData.housingId,
						notes: stayData.roomRequests.notes
					},
					dataType: 'json',
					url: '/saveRequests',
					type: 'POST'
				});
			}
			
			// Chain the calls to ensure sequential execution
			actModify()
				.then(function (data) {
					compass.loading.stop();
					return sendConfirmation();
				})
				.then(function () {
					return saveRequests();
				})
				.then(function (data) {
					_dialog.close();
					window.location.reload(); // Final step: reload page after saveRequests
				})
				.fail(function (error) {
					console.error("Error occurred during the chained AJAX calls:", error);
			
					compass.GA.trackEvent('Error', 'View', 'Names - Requests Error');
					d.alert({
						message: [d.div({className: 'bold'}, 'We\'re sorry, there was a problem adding hotel requests to the reservation.'), d.div('Please try again. If there is still a problem, you may email customerservice@onpeak.com for assistance.')],
					});
				});
		};

		var _handleCancel = function (event, data) {
			var cancelDialogId = data.dialogId || '';
			var container = d.div();
			var cancelValidator = new compass.validator({
						onValid : function (e) { e.removeClass('invalid'); },
						onInvalid: function (e) { e.addClass('invalid'); }
					});
			var cancelWidget = new compass.hotel.CancelRoomWidget(container, {
										cancelFee : _info.cancelFee,
										currencyFormatter : _settings.meetingInfo.defaultCurrencyFormatter,
										validator: cancelValidator,
										cancelReasons : _settings.cancelReasons
									});

			var cancelButton = cancelWidget.getCancelButton();
			var checkbox = cancelWidget.getCheckbox();
			checkbox.addClass('disabled');

			cancelWidget.bind('CancelRoomWidget.cancelFeeCheckboxChanged', function(event) {
				if (checkbox.length > 0 && checkbox.is(":checked")) {
					checkbox.removeClass('invalid');
					cancelButton.removeClass('disabled');
				} else if (checkbox.length > 0) {
					checkbox.addClass('invalid');
					cancelButton.addClass('disabled');
				} else {
					return;
				}
			});

			cancelWidget.bind('CancelRoomWidget.cancelReasonsChanged', function(event, values) {
				var values = cancelWidget.getValues();
				if (values.reason >= 0 && (checkbox.is(":checked") || checkbox.length === 0)) {
					cancelButton.removeClass('disabled');
				}
			});

			cancelWidget.bind('CancelRoomWidget.Cancel', function (event, data) {
				data.housing_id= stay.housingId;

				var fields = cancelValidator.validate();
				if (fields.length > 0) {
					return;
				}

				jQuery.ajax({
					url: '/actCancel',
					type: 'POST',
					data: data,
					success: function(data) {
						cancelDialog.close();
						_dialog.close();
						jQuery.ajax({
							url : '/sendConfirmation',
							success : function(data) {
								window.location.reload();
							}
						});
					}
				});
			});

			var cancelDialog = d.dialog({
				contents: container,
				classes: "individualFrontDesk CancelDialog",
				showParent: true,
				idGenerator: compass.generateId,
				dialogId: cancelDialogId
			});
		};

		var _editResWidget;
		var editResHolder;
		jQuery.ajax({
			url: '/editRoom',
			data: {
				housing_id: hotelInfo.housingId,
				blocked_room_id: hotelInfo.blockedRoomId,
				hotel_id: hotelInfo.hotelId
			},
			retryLimit: 3,
			success: function(data) {
				var requestsData = data.requests;
		
				// Instantiate the widget here
				editResHolder = _d.div();
				_editResWidget = new compass.hotel.EditReservationWidget(editResHolder, {
					meetingInfo: _settings.meetingInfo,
					roomTypes: info.roomTypes,
					payment: info.payment,
					storedCards: info.stored,
					stay: stay,
					hotelName: hotelInfo.hotelName,
					countriesAndStates: _settings.countriesAndStates,
					maskCCNumber: _.contains(info.extraRequiredFields, 'maskCreditCard'),
					blockChargeInfo: info.blockChargeInfo,
					individualChargeInfo: info.individualChargeInfo,
					canEditRoom: hotelInfo.canEditRoom,
					frequentGuestNumber: info.stay.frequent_guest_number,
					requestsInfo: requestsData
				});

				_editResWidget.bind('EditReservationWidget.update', _handleUpdate);
			 	_editResWidget.bind('EditReservationWidget.cancel', _handleCancel);

				 _dialog = _d.dialog({
					classes: "editReservation",
					contents: editResHolder,
					idGenerator: compass.generateId, // will apply this id to the first header it finds within the dialog
					dialogId : _dialogId // the dom id of the dialog itself
				});
				_dialogId = ''; // clear the dialog id for any other dialogs that might be spawned later
			}
		});
	};

	var _drawGDSDetails = function (hotelInfo, roomData) {
		var gdsDetailsHolder = _d.div();
		roomData.meetingInfo =  _settings.meetingInfo;
		var gdsDetailsWidget = new compass.group.GDSInfoWidget(gdsDetailsHolder, roomData);
		_dialog = _d.dialog({
			classes: "GDSInfo",
			contents: gdsDetailsHolder
		});
	};
	
	var _drawEPSDetails = function (hotelInfo, roomData) {
		var epsDetailsHolder = _d.div();
		roomData.meetingInfo =  _settings.meetingInfo;
		roomData.hotelInfo =  hotelInfo;
		
		var _handleCancel = function (event, data) {
			var cancelDialogId = data.dialogId || '';
			var cancelContainer = d.div();
			var cancelValidator = new compass.validator({
				onValid : function (e) { e.removeClass('invalid'); },
				onInvalid: function (e) { e.addClass('invalid'); }
			});
			var cancelWidget = new compass.hotel.CancelRoomWidget(cancelContainer, {
				currencyFormatter : _settings.meetingInfo.defaultCurrencyFormatter,
				validator: cancelValidator,
				cancelReasons : _settings.cancelReasons
			});

			var cancelButton = cancelWidget.getCancelButton();
			var checkbox = cancelWidget.getCheckbox();
			checkbox.addClass('disabled');

			cancelWidget.bind('CancelRoomWidget.cancelReasonsChanged', function(event, values) {
				var values = cancelWidget.getValues();
				if (values.reason >= 0 && (checkbox.is(":checked") || checkbox.length === 0)) {
					cancelButton.removeClass('disabled');
				}
			});

			cancelWidget.bind('CancelRoomWidget.Cancel', function (event, data) {
				data.eps_itinerary_id = roomData.eps_itinerary_id;

				var fields = cancelValidator.validate();
				if (fields.length > 0) { return; }

				jQuery.ajax({
					url: '/actEPSCancel',
					type: 'POST',
					data: data,
					success: function(data) {
						if (data.epsSuccess) {
							cancelDialog.close();
							_dialog.close();
							jQuery.ajax({
								url : '/sendConfirmation',
								success : function(data) {
									window.location.reload();
								}
							});
						} else {
								compass.GA.trackEvent('Error', 'View', 'Expedia - Cancel/Modification');
								var popupParams = {
									title: 'Unable to cancel',
									message: 'We are unable to complete your cancellation. Click OK to view our phone number and business hours for assistance in cancelling your reservation.',
									triggerName: 'epsCancelWidgetErrorReturn'
								};
								var errorMessage = d.div();
								var textPopupWidget = new compass.arctic.TextPopupWidget(errorMessage, popupParams);
								var textPopupWidgetDialog = d.dialog({
									classes: 'frontDesk textPopupWidget',
									contents: errorMessage,
									centerOnView: true,
									showCloseButton: false
								});
								textPopupWidget.bind('epsCancelWidgetErrorReturn', function () {
									cancelDialog.close();
									textPopupWidgetDialog.close();
								});
						}
					}
				});
			});

			var cancelDialog = d.dialog({
				contents: cancelContainer,
				classes: "individualFrontDesk CancelDialog",
				showParent: true,
				idGenerator: compass.generateId,
				dialogId: cancelDialogId
			});
		};
		
		var gdsDetailsWidget = new compass.group.EPSInfoWidget(epsDetailsHolder, roomData);
		gdsDetailsWidget.bind('EPSInfoWidget.cancel', _handleCancel);
		
		var _showPolicies = function(e, data) {
			var hotelInfo = _pageJSON.HotelPictureSummaryTileWidget.reservationsArray[0];

			var policiesDiv = d.div({className:'policiesContainer'});
			_policiesDialog = d.dialog({
				classes: 'hotelInfo policiesDialog',
				contents: policiesDiv,
				centerOnView: true,
				showParent: true
			});
			compass.loading.start(policiesDiv);

			jQuery.ajax({
				dataType:'json',
				traditional: true,
				url:'/epsPolicies',
				success : function(data) {
					_policiesWidget = new compass.hotel.GDSPoliciesWidget(policiesDiv, {
						WUID: 'GDS_policiesWidget_individualinfo',
						policies: {
							gdsHotelPolicies: {
								refundable: data.refundable,
								hotelName: hotelInfo.hotelName,
								roomName: data.roomName,
								depositPolicy: data.depositPolicy,
								cancelPolicy: data.cancelPolicy,
								checkinTwentyFourHour: data.checkinTwentyFourHour,
								checkinBeginTime: data.checkinBeginTime,
								checkinEndTime: data.checkinEndTime,
								checkoutTime: data.checkoutTime,
								checkinMinAge: data.checkinMinAge,
								checkinInstructions: data.checkinInstructions,
								checkinSpecialInstructions: data.checkinSpecialInstructions,
								mandatoryFees: data.mandatoryFees,
								knowBeforeYouGo: data.knowBeforeYouGo,
								petPolicies: data.petPolicies,
								generalPolicies: data.generalPolicies,
								optionalFees: data.optionalFees,
								frontDesk: true
							} 
						},
						affiliateHandledByOurAgent: _settings.meetingInfo.affiliateHandledByOurAgent,
						phone: _settings.meetingInfo.phone
					});
				},
				complete : function() {
					compass.loading.stop();
				}
			});
		};
		gdsDetailsWidget.bind('EPSInfoWidget.policies', _showPolicies);

		_dialog = _d.dialog({
			classes: "EPSInfo",
			contents: epsDetailsHolder
		});
	};

	/*
	 * setup all the controls.
	 */
	var _setupControls = function(data) {
	};/* end of setup controls. */

	$j('body').bind('ListLoaderWidget.DownloadRoster', function(event, eventData) {
		var _checkDownloadInterval;
		var interval = 250;
		var button = eventData.button;
		Cookies.set('download', false, { path: '/'});
		window.location = window.location.pathname+'/downloadList';
		button.addClass('disabled');
		compass.loading.start(button.empty(), { color : '#FFFFFF' });
		_checkDownloadInterval = setInterval(function() {
			if (Cookies.get('download') === 'true') {
				compass.loading.stop();
				button.removeClass('disabled');
				button.append(eventData.buttonText);
				clearInterval(_checkDownloadInterval);
				Cookies.remove('download', { path: '/' });
			}
		}, interval);
	});

	$j('body').bind('ListLoaderTransferWidget.UploadList', function(event, eventData) {
		$j.ajax({
			data: eventData.file,
			type: 'POST',
			url: '/uploadList',
			cache: false,
			contentType: false,
			processData: false,
			success: function(data) {
				if (data.valid === true) {
					eventData.callback(data);
				} else {
					eventData.errorCallback();
				}
			},
			error: function() {
				eventData.errorCallback();
			}
		});
	});

	$j('body').bind('ListLoaderSubmissionResultsWidget.ProcessListMember', function(event, eventData) {
		_processListMember(eventData);
	});

	// extracted this ajax request from the bind above so that it could easily be called recursively
	var _processListMember = function(listData) {
		$j.ajax({
			data: {list_id: listData.list_id},
			type: 'GET',
			dataType: 'json',
			url: '/processListMember',
			success: function(data) {
				$j('.ListLoaderProcessingWidget').trigger('ListLoaderProcessingWidget.updateProcessedReservations', {processed: data.processed, total: data.total});
				if (data.moreToDo) {
					_processListMember(listData);
				} else {
					_sendConfirmation();
				}
			},
			error: function() {
				_sendConfirmation(true);
			}
		});
	};

	$j('body').bind('ListLoaderWidget.GA', function(event, eventData) {
		compass.GA.trackEvent('Roster', eventData.action, 'Front Desk');
	});

	var _sendConfirmation = function(processingError) {
		jQuery.ajax({
			url : '/sendConfirmation',
			complete : function(data) {
				if (processingError) {
					$j('.ListLoaderProcessingWidget').trigger('ListLoaderProcessingWidget.errorProcessing');
				} else {
					$j('.ListLoaderProcessingWidget').trigger('ListLoaderProcessingWidget.finishProcessing');
				}
			}
		});
		
	};

	var _navigateTo = function(route) {
		_clearEvents();
		_viewport.trigger(CompassEvents.Navigate, route);
	};

	this.run = function(renderComplete) {
		_viewport.trigger(CompassEvents.InvalidateView, 'hotels');
		compass.loading.start();
		jQuery.ajax({
			url : '/summaryInfo',
			data : {},
			success : function(data) {
				compass.loading.stop();
				_pageJSON = data;
				_settings.countriesAndStates = data.countriesAndStates;
				_settings.cancelReasons = data.cancelReasons;
				_settings.accountInfo = data.accountInfo;
				_settings.chargingInfo = data.chargingInfo;
				_settings.showExtraFrontDeskVerbiage = data.showExtraFrontDeskVerbiage;
				if (data.group_info !== undefined){
					_settings.paymentInfo = data.group_info.payments;
					hasGIN = data.group_info.hasGIN;
				}
				_settings.canSendConfo = data.canSendConfo != null ? data.canSendConfo : _settings.meetingInfo.canSendConfo;

				/* if we get into a weird state where we are not logged in, we should be forwarded to the front page instead of being*/
				/* stuck on the front desk with no widgets showing */
				if(_pageJSON.notLoggedIn){
					_navigateTo('entry');
					return;
				}

				_eventType = _eventTypes[_pageJSON.pageSpecificData.userType];
				compass.trackPageView(_eventType, {
								src : 'arctic.views.common.frontDesk'
				});


				_render(jQuery.dom);
				// move this into a renderer for testing.
				_setupControls(data);
				// sets up controls on the widgets. setups controls on the view itself.
				compass.loading.stop();

				var trackRegTileError = function() {
					compass.GA.trackEvent('Front Desk Tile', 'Registration Tile Error', 'Request to get registration tile contents failed');
				};

				if(_pageJSON.areAffiliateRegTransfersOn) {
					compass.GA.trackEvent('Front Desk Tile', 'Tile Display', 'Reg Tile');
					compass.loading.start(_registerTileWidget.find('.loadingSpinner'));
					jQuery.ajax({
						url: '/regSummaryInfo',
						data: {	pageSpecificData: JSON.stringify(_pageJSON.pageSpecificData) },
						contentType : 'application/json',
						success: function(data) {
							if(data.error) {
								trackRegTileError();
								_registerTileWidget.displayShowLink(_settings.meetingInfo.homePageUrl, ( data.regData ? data.regData.target : '_blank'));
							} else {
								_registerTileWidget.asyncLoad({ regURL : data.regData.url, target : data.regData.target });
							}
							compass.loading.stop();
						},
						error: function(jqXHR, status, error) {
							trackRegTileError();
							compass.loading.stop();
							_registerTileWidget.displayShowLink(_settings.meetingInfo.homePageUrl,'_blank');
						}
					});
				}

				// trigger the event to let godview know that a view has loaded and return a string that can be prepended to the header widget
				// for better screen reading of the page
				_viewport.trigger(CompassEvents.ViewLoaded, 'Reservation Summary – A confirmation email has been sent. Use options below to review reservation information and make changes');
				// stops measuring the time it takes the view to load
				compass.stopLoad('frontDesk');
				renderComplete();
			}
		});
	};
};

